module.exports = __webpack_public_path__ + "img/app-landing-awesome.392b0034.png";